<template>
    <div class="customer-groups-picker">
        <div class="m-5" v-if="!loading">
            <a-table
                :key="'vtable-' + renderCount"
                :rowKey="`_id`"
                :columns="columns"
                :dataSource="customerGroups"
                :pagination="{ pageSize: 5, showSizeChanger: true, showQuickJumper: true }"
                :customRow="
                    (record) => {
                        return {
                            props: {},
                            on: {
                                click: (event) => {
                                    rowClicked(record);
                                },
                            },
                        };
                    }
                "
                :rowClassName="getRowClassName"
            >
                <span slot="indexTitle"> # </span>
                <span slot="nameTitle"> {{ $t("wp.name") }} </span>
                <span slot="descriptionTitle"> {{ $t("wp.description") }}</span>
                <span slot="contactsTitle"> {{ $t("wp.contacts") }}</span>

                <template slot="index" slot-scope="text, record">
                    <span v-if="selectedRowId === record._id" class="text-success" style="font-size: 16px">
                        <a-icon type="check" />
                    </span>
                    <span v-else>{{ text }}</span>
                </template>
                <template slot="avatar" slot-scope="text, record">
                    <div
                        class="customer-group-avatar text-center"
                        :class="{ 'customer-group-avatar-odd': record.index % 2 === 0 }"
                    >
                        <md-highlight-text md-term="term" class="text-center">
                            {{ record.name.slice(0, 2).toUpperCase() }}
                        </md-highlight-text>
                    </div>
                </template>

                <span slot="contacts" slot-scope="text, record">
                    {{
                        $_.get(record, "contacts.length", 0)
                            ? `${$_.get(record, "contacts.length", 0)} Contact`
                            : $t("wp.noContactFound")
                    }}</span
                >
                <span slot="description" slot-scope="text, record">{{ $_.get(record, "description", "-") }}</span>
            </a-table>
        </div>
        <div v-else>
            <a-spin></a-spin>
        </div>
    </div>
</template>

<script>
import WHATSAPP_API from "../../../../api/whatsapp";
import log2 from "../../../../utils/log2";
import { message } from "ant-design-vue";

const columns = [
    {
        dataIndex: "index",
        key: "index",
        slots: { title: "indexTitle" },
        scopedSlots: { customRender: "index" },
    },
    {
        dataIndex: "avatar",
        key: "avatar",
        slots: { title: "" },
        scopedSlots: { customRender: "avatar" },
        width: "5%",
    },

    {
        dataIndex: "name",
        key: "name",
        slots: { title: "nameTitle" },
        scopedSlots: { customRender: "name" },
    },
    {
        dataIndex: "description",
        key: "description",
        slots: { title: "descriptionTitle" },
        scopedSlots: { customRender: "description" },
    },
    {
        dataIndex: "contacts",
        key: "contacts",
        slots: { title: "contactsTitle" },
        scopedSlots: { customRender: "contacts" },
    },
];
const log = log2("CustomerGroupsPicker");
export default {
    name: "CustomerGroupsPicker",
    props: {
        onSelectChanged: {
            type: Function,
        },
        defaultSelectedGroupId: {
            type: String,
        },
    },
    components: {},
    data() {
        return {
            customerGroups: [],
            columns,
            loading: false,
            renderCount: 0,
            selectedRowId: this.defaultSelectedGroupId,
        };
    },
    methods: {
        rowMouseOver(record) {
            if (this.selectedRowId !== record._id) {
                this.selectedRowId = record._id;
            }
        },
        rowMouseLeave(record) {
            if (this.selectedRowId === record._id) {
                this.selectedRowId = null;
            }
        },
        fetchCustomerGroups() {
            this.loading = true;
            WHATSAPP_API.BROADCAST.listGroups()
                .then((res) => {
                    this.customerGroups = res.data.map((group, index) => {
                        return {
                            ...group,
                            index: index + 1,
                        };
                    });

                    if (!this.defaultSelectedGroupId && !!this.customerGroups[0]) {
                        this.selectedRowId = this.customerGroups[0]._id;
                        this.onSelectChanged(this.customerGroups[0]);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        rowClicked(record) {
            this.selectedRowId = record._id;
            this.onSelectChanged(record);
        },
        getRowClassName(record, index) {
            const classList = ["customer-group-row"];
            if (record._id === this.selectedRowId) classList.push("selected");
            if (index % 2 === 0) classList.push("even");
            return classList.join(" ");
        },
    },
    mounted() {
        this.fetchCustomerGroups();
    },
    watch: {
        defaultSelectedGroupId(newVal) {
            this.selectedRowId = newVal;
        },
    },
};
</script>

<style lang="scss">
.customer-groups-picker {
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;

    .customer-group-row {
        cursor: pointer;

        &.selected {
            background-color: #03a9f461 !important;
        }

        &.even {
            background-color: #f9f9f9;
        }
    }

    .ant-table table {
        width: 100% !important;
        text-align: left !important;
        border-radius: 4px 4px 0 0 !important;
        border-collapse: separate !important;
        border-spacing: 0 !important;
    }

    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
        padding: 16px 16px !important;
        overflow-wrap: break-word !important;
    }

    .ant-table-tbody > tr > td {
        padding: 16px 16px !important;
        border-bottom: 1px solid #e8e8e8 !important;
        -webkit-transition: background 0.3s !important;
        transition: background 0.3s !important;
    }

    .ant-table-row-cell-break-word {
        word-wrap: break-word !important;
        word-break: break-word !important;
    }

    .ant-table {
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: rgba(0, 0, 0, 0.65) !important;
        font-size: 14px !important;
        font-variant: tabular-nums !important;
        line-height: 1.5 !important;
        list-style: none !important;
        -webkit-font-feature-settings: "tnum" !important;
        font-feature-settings: "tnum" !important;
        position: relative !important;
        clear: both !important;
    }

    .ant-card {
        -webkit-box-sizing: border-box !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        color: rgba(0, 0, 0, 0.65) !important;
        font-size: 14px !important;
        font-variant: tabular-nums !important;
        line-height: 1.5 !important;
        list-style: none !important;
        -webkit-font-feature-settings: "tnum" !important;
        font-feature-settings: "tnum" !important;
        position: relative !important;
        background: #fff !important;
        border-radius: 2px !important;
        -webkit-transition: all 0.3s !important;
        transition: all 0.3s !important;
    }

    .ant-table-body {
        ant-table-thead {
            margin-bottom: 10px !important;
        }

        tr {
            padding: 16px 16px !important;
            overflow-wrap: break-word !important;
            cursor: pointer;
        }

        td {
            font-family: Poppins !important;
            font-size: 12px !important;
            font-weight: 400 !important;
            color: #181c32 !important;
            border-bottom: none !important;
            padding: 16px 16px !important;
            overflow-wrap: break-word !important;
        }

        th {
            border-right: unset !important;
            border-bottom: 1px solid #e8e8e8 !important;
            padding: 0px 16px !important;
            overflow-wrap: break-word;

            &:last-child {
                border-right: unset !important;
            }
        }
    }

    .ant-table-body tbody td {
        border-right: unset !important;
        padding: 16px 16px !important;

        &:last-child {
            border-right: unset !important;
        }
    }

    .ant-table-thead > tr > th {
        background: #ffffff;
    }

    .operation-buttons {
        max-width: 0px;
        cursor: pointer;

        &.hidden {
            .operation-button {
                display: none;
            }
        }
    }

    .customer-group-avatar {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #6899c1;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }

    .customer-group-avatar-odd {
        display: flex;
        align-items: center;
        font-size: 16px;
        background: #c980a3;
        border-radius: 50%;
        height: 35px;
        width: 35px;
    }
}
</style>
